<template>
    <mini-button :loading="downloading" name="导出" @btnClick="whenExportClick">
        <i class="fa-solid fa-file-export"></i>
    </mini-button>
</template>

<script>
import MiniButton from "@/components/common/buttons/MiniButton.vue";
import emCommonUtilMixin from "@/mixin/em/common/stuffs/utils/emCommonUtilMixin";
import {mapToList} from "@/plugins/configure-query-helper";
import dayjs from "dayjs";

export default {
    name: "ExcelExportBtn",
    mixins: [emCommonUtilMixin],
    components: {MiniButton},
    props: {
        configId: [String, Number],
        service: String,
        filter: Object,
    },
    data() {
        return {
            downloading: false,
        }
    },
    computed: {
        baseUri() {
            return `${process.env.VUE_APP_EM_GATEWAY_URL}/${this.service}/qg`;
        },
        baseParam() {
            return `id=${this.configId}&locale=${this.$i18n.locale()}`;
        },
    },
    methods: {
        whenExportClick() {
            // this.$refs.import.showModal();
            this.doExport();
        },
        doExport() {
            if (this.configId && this.service) {
                this.downloading = true;
                let url = `${this.baseUri}/export/excel?${this.baseParam}`;
                this.downloadWithHeader(url, `Export-${dayjs().format()}.xlsx`,
                    () => this.downloading = false,
                    'POST', {
                        where: mapToList(this.filter)
                    });
            } else {
                this.$message.warning("Config Not Found")
            }
        },
    }
}
</script>

<style scoped>
.w-100 >>> .b-form-file .custom-file-label {
    width: 100%;
}
</style>
